import { useMemo } from 'react';
import { dimensionsCategory } from '@utils/dimension/dimensionCategories';
import { CURRENT_PRODUCT_MODE } from '@utils/constants';

function useDimensionsCategories({
  allDimensions,
  selectedDimensionsList,
  excludeCategories = [] as string[],
  hiddenEmptyCategory = false,
}) {
  const dimensionsCategories = useMemo(() => {
    const categoryMap = {};
    const currentDimensionCategory = dimensionsCategory[CURRENT_PRODUCT_MODE];
    Object.keys(currentDimensionCategory).forEach((category) => (categoryMap[category] = []));

    allDimensions.forEach(({ category, groupBy, name }) => {
      if (category) {
        const checked = selectedDimensionsList.includes(groupBy);

        categoryMap[category]?.push({
          key: groupBy,
          name: name,
          checked,
        });
      }
    });

    // exclude ad category when FF is false
    excludeCategories.forEach((category) => {
      delete categoryMap[category];
    });

    for (const category of Object.keys(categoryMap)) {
      categoryMap[category].sort((a, b) => a.name.localeCompare(b.name));
    }

    if (hiddenEmptyCategory) {
      Object.keys(categoryMap).map((it) => {
        if (!categoryMap[it] || !categoryMap[it].length) {
          delete categoryMap[it];
        }
      });
    }

    return categoryMap;
  }, [allDimensions, selectedDimensionsList, excludeCategories, hiddenEmptyCategory]);

  return dimensionsCategories;
}

export default useDimensionsCategories;
